module.exports = __webpack_public_path__ + "img/background-tender-2.614bb2fe.png";